/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class Conta {
    public static inicializar() {
      var conta = new App.Conta();
      conta.inicializarEventos();
    }
  }
}

namespace App {
  export class Conta {
    private ajax: IAjax;

    private elementoLinkAtivarDesativarRenovacaoAutomatica: JQuery = $("#renovacaoAutomatica");
    private elFormDadosPessoais: JQuery = $("#formularioDados");
    private elFormAlterarSenha: JQuery = $("#formularioAlterarSenha");
    private elLinkRemoverConta: JQuery = $(".remover-conta");
    private elBtnDesconectarTelegram: JQuery = $(".btn-desconectar-telegram");
    private elBtnLimparRegAntigos: JQuery = $("#limparRegAntigos");

    // ### Acoes datatable contas vinculadas ############################
    private objSelect2: ISelect2 = null;
    private elBtnSelecionarTodosOsFiltros: JQuery = $(".btn-selecionar-todos-os-filtros");
    private elBtnApagarTodosOsFiltros: JQuery = $(".btn-apagar-todos-os-filtros");
    private elTabelaContasvinculadas: JQuery = $("#dataTableContasVinculadas")
    private elBtnAplicarProfile: JQuery = $(".btn-aplicar-profile");
    private elBtnAplicarFiltros: JQuery = $(".btn-aplicar-filtros");
    private urlAplicarPerfil: string = null;
    private urlAplicarFiltro: string = null;
    // ##########################################################################


    private modelViewContasVinculadas: any = null;


    public inicializarEventos() {
      this.inicializarAtivarDesativarRenovacaoAutomatica();
      this.elBtnDesconectarTelegram.on("click", (e) => { this.desconectarTelegram(e) });
      this.elBtnLimparRegAntigos.on('click', (e) => { this.aoLimparRegistrosAntigos(e); });

      // ### Acoes datatable contas vinculadas ############################
      this.objSelect2 = new Select2();
      this.objSelect2.inicializarCampo($('.select2'));
      this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());
      this.elBtnSelecionarTodosOsFiltros.on("click", (e) => { this.aoSelecionarTodosOsFiltros(e) });
      this.elBtnApagarTodosOsFiltros.on("click", (e) => { this.aoApagarTodosOsFiltros(e) });
      this.elBtnAplicarProfile.on("click", (e) => { this.aoAplicarPerfil(e) });
      this.elBtnAplicarFiltros.on("click", (e) => { this.aoAplicarFiltros(e) });
      // ##########################################################################
      this.inicializarCrudContasVinculadas();
      $(document).on('click', '.remover-conta', (e) => { this.aoExcluirRegistro(e) });
    }

    private inicializarAtivarDesativarRenovacaoAutomatica() {
      this.elementoLinkAtivarDesativarRenovacaoAutomatica.on('click', (e) => { this.aoDesativarRenovacaoAutomatica(e) });
      this.elFormDadosPessoais.on('submit', (e) => { this.aoSubmeterFormulario(e) });
      this.elFormAlterarSenha.on('submit', (e) => { this.aoSubmeterFormulario(e) });
    }

    private aoDesativarRenovacaoAutomatica(e: JQueryEventObject) {
      var elemento = $(e.target);
      if (elemento.data('renovacao_automatica') === 1) {
        this.ativarDesativarRenovacaoAutomatica(e)
      } else {
        App.Util.exebirSweetConfirmacao(e, "Você tem certeza disso?", "Se cancelado, ao final da sua assinatura não ocorrerá mais a renovação automática.", "Sim, continuar", this.ativarDesativarRenovacaoAutomatica);
      }
    }

    private aoSubmeterFormulario(e: JQueryEventObject) {
      App.Util.exibirModalPaginaCarregando();
    }

    private ativarDesativarRenovacaoAutomatica(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      var elemento = $(e.target);
      var dados: any = { renovacao_automatica: elemento.data('renovacao_automatica') };
      this.ajax.postAcao($(e.target).data("url"), dados);
    }

    private aoExcluirRegistro(e: JQueryEventObject) {
      console.log('excluir conta id: ', $(e.currentTarget).data("id"), $(e.currentTarget).data("url"));
      let el = $(e.currentTarget);
      let id = $(e.currentTarget).data("id")
      let url = $(e.currentTarget).data("url")

      var textoExclusao: string = "Essa conta EA será removida/inutilizada, ou seja, <b>não poderá</b> ser utilizada <b>nessa</b> e <b>nem em outra</b> conta FUTSNIPERWEB que <b>não tenha Plano</b> ou que <b>tenha Plano Trial</b> e só poderá ser reativada mediante autorização da nossa equipe.";
      if ($(e.currentTarget).data('vendedor')) {
        textoExclusao = "Sua conta EA será desvínculada da conta FUTSNIPERWEB";
      }

      swal.fire({
        title: "Você tem certeza disso?",
        html: textoExclusao,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, continuar",
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.excluirRegistro({ id: id, url: url, el: el });
        }
      });
      return;
    }

    private excluirRegistro(parametros: any) {
      this.ajax = new App.Ajax();
      console.log('excluir conta id: ', parametros.id, parametros.url);
      this.ajax.postAcaoSemCabecalhoGlobal(parametros.url, { id: parametros.id }, App.Conta.excluirRegistroNaPagina, parametros);
    }

    public static excluirRegistroNaPagina(dados: IRespostaSucessoAjx) {
      let { id, url, el } = dados.parametroCallback;
      console.log('excluirRegistroNaPagina id: ', id, url, el);
      el.parents("tr").remove();
    }

    private desconectarTelegram(e: JQueryEventObject) {
      Util.exibirModalPaginaCarregando();
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("urlDesconectar"), { id: $(e.currentTarget).data("id") }, App.Conta.excluirRegistroNaPagina, e);
    }

    private aoLimparRegistrosAntigos(e: JQueryEventObject) {
      console.log('limpar registros antigos: ');
      let ajax = new Ajax();
      ajax.postAcao('/sniper-detalhes-limpar', {}, (dadosSucesso: IRespostaSucessoAjx) => {
        swal.fire("Pronto!", "Os dados antigos foram removidos com sucesso.", "info");
      });
    }

    private inicializarCrudContasVinculadas() {
      let ehPlanoProOuCloud = this.elTabelaContasvinculadas.data('planoprocloud')
      this.urlAplicarPerfil = this.elTabelaContasvinculadas.data('urlAplicarPerfil')
      this.urlAplicarFiltro = this.elTabelaContasvinculadas.data('urlAplicarFiltro')
      console.log('inicializarCrudServidor4:', ehPlanoProOuCloud, this.urlAplicarPerfil, this.urlAplicarFiltro);
      this.modelViewContasVinculadas = new ModelView();
      this.modelViewContasVinculadas.ojDataTableCarregado.elDataTable = this.elTabelaContasvinculadas;
      this.modelViewContasVinculadas.carregardataTable(ehPlanoProOuCloud ?
        [
          {
            className: "btn-sm btn-outline-primary btn-selecionar-tudo",
            text: '<i title="Select/Unselect all" class="fas fa-check-double font-size-11 m-0"></i>',
            action: () => {
              let itensSelecionados = this.modelViewContasVinculadas.getContasSelecionadas()
              let count = itensSelecionados.count();
              if (count) {
                this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.rows().deselect();
              } else {
                this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.rows().select();
              }
            }
          },
          {
            className: "btn-sm btn-outline-primary btn-aplicar",
            text: '+ Perfil',
            action: () => {
              let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
              var count = contasSelecionadas.count();
              if (count) {
                $("#modalAplicarPerfil").modal("show")
              }
            }
          },
          {
            className: "btn-sm btn-outline-primary btn-dt-aplicar-filtros",
            text: '+ Filtros',
            action: () => {
              let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
              var count = contasSelecionadas.count();
              if (count) {
                $("#modalAplicarFiltros").modal("show")
              }
            }
          }
        ] : [],
        500
      )

      this.inicializarEventosDataTables()
    }

    private async aoAplicarPerfil(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarPerfil"));

      // Obter os IDs das contas selecionadas
      const contasIds = this.modelViewContasVinculadas.getIdsContasSelecionadas();
      console.log("IDS", contasIds);

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(contasIds, 100);
      $("#modalAplicarPerfil").modal('hide')

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.contas_ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.aplicarPerfilAsync(dadosForm, lote);
        }

        App.Util.ocultarModalPaginaCarregando();
        // Exibir mensagem de sucesso após todos os lotes serem processados
        swal.fire({
          icon: 'success',
          title: 'Perfil Aplicado!',
          text: 'O perfil foi aplicado às contas selecionadas. Atualize a página para visualizar as alterações.'
        });
      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Aplicar Perfil',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private aplicarPerfilAsync(dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(this.urlAplicarPerfil, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { perfil: { id: number, nome: string } } } }) => {
          console.log(`Lote com ${lote.length} contas processado com sucesso.`);
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false)
      });
    }

    private async aoAplicarFiltros(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      let dadosForm: any = this.ajax.convertFormToJSON($("#formAplicarFiltros"));

      // Obter os IDs das contas selecionadas
      const contasIds = this.modelViewContasVinculadas.getIdsContasSelecionadas();
      console.log("IDS", contasIds);

      // Dividir os IDs em lotes de 100
      const lotes = App.Util.chunkArray(contasIds, 100);
      $("#modalAplicarFiltros").modal('hide');

      try {
        // Processar os lotes de forma assíncrona, um por vez
        for (const lote of lotes) {
          // Atualizar os dados do formulário com o lote atual
          dadosForm.contas_ids = lote;

          // Enviar a requisição para o servidor como uma promessa
          console.log(`Enviando lote com ${lote.length} contas...`);
          await this.aplicarFiltrosAsync(dadosForm, lote);
        }

        // Exibir mensagem de sucesso após todos os lotes serem processados
        App.Util.ocultarModalPaginaCarregando();
        swal.fire({
          icon: 'success',
          title: 'Filtros Aplicados!',
          text: 'Os filtros foram aplicados às contas selecionadas. Atualize a página para visualizar as alterações.'
        });
      } catch (error) {
        App.Util.ocultarModalPaginaCarregando();
        // Tratar erros durante o processamento dos lotes
        console.error(`Erro ao processar lote:`, error);
        swal.fire({
          icon: 'error',
          title: 'Erro ao Aplicar Filtros',
          text: 'Ocorreu um erro ao processar um dos lotes. Verifique sua conexão e tente novamente.'
        });
      }
    }

    // Função para enviar um lote como uma promessa
    private aplicarFiltrosAsync(dadosForm: any, lote: any[]): Promise<void> {
      return new Promise((resolve, reject) => {
        this.ajax.postAcao(this.urlAplicarFiltro, dadosForm, (resposta: { dadosEnviados: any, dadosRetornados: { dadosResposta: { filtros: any[] } } }) => {
          console.log(`Lote com ${lote.length} contas processado com sucesso.`);
          resolve(); // Resolve a promessa quando a requisição for concluída
        }, null, true, false)
      });
    }

    private aoSelecionarTodosOsFiltros(e: JQueryEventObject) {
      try {
        var options = $('#filtro option');
        $('#filtro').val(options.map(function () { return this.value; }).get()).trigger('change');
      } catch (e) {
      }
    }

    private aoApagarTodosOsFiltros(e: JQueryEventObject) {
      try {
        $('#filtro').val("").trigger('change');
      } catch (e) {
      }
    }

    private inicializarEventosDataTables() {
      let aoSelecionarOuDeselecionar = (e: any, dt: any, type: any, indexes: any) => {
        if (type === 'row') {
          let contasSelecionadas = this.modelViewContasVinculadas.getContasSelecionadas()
          var count = contasSelecionadas.count();
          $('.btn-aplicar').html(count > 0 ? `+ Perfil (${count})` : `+ Perfil`)
          $('.btn-dt-aplicar-filtros').html(count > 0 ? `+ Filtros (${count})` : `+ Filtros`)
        }
      }

      this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.on('select', aoSelecionarOuDeselecionar);
      this.modelViewContasVinculadas.ojDataTableCarregado.objDataTable.on('deselect', aoSelecionarOuDeselecionar);

    }
  }
}
